<template>
	<div class = "box">
		<OrderCode  v-if="orderDetail.orderType == 1" :status = "orderDetail.status" :takeFoodCode = "orderDetail.takeFoodCode"></OrderCode>
		<div class = "shop-detail-div" v-if="orderDetail.orderType == 1">
			<ComShopLocation :shopName="orderDetail.storeName" :shopAddress="orderDetail.address" ></ComShopLocation>
		</div>
		<div class = "shop-pay-goods-div">
			<OrderGoods :orderDetail = "orderDetail"></OrderGoods>
		</div>
		<div class="emtry-div"></div>
		<ComTabbar></ComTabbar>
	</div>
</template>

<script>
	import { getOrderById } from '@/request/api';
	import OrderCode from '../components/orderDetail/OrderCode.vue'
	import ComTabbar from '../components/orderDetail/ComTabbar.vue'
	import ComShopLocation from '../components/goods/ComShopLocation.vue'
	import OrderGoods from '../components/orderDetail/OrderGoods.vue'
	import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
	export default {
		name: 'orderDetail',
		computed: mapGetters(["sOrderId","sHfOrderId"]),
		components: {
		      [OrderCode.name]: OrderCode,
		      [ComShopLocation.name]: ComShopLocation,
		      [OrderGoods.name]: OrderGoods,
		      [ComTabbar.name]: ComTabbar,
		      
		 },
		 created(){
			 this.pollGetOrder()
		 },
		data(){
			return {
				orderDetail:'',
				orderTimer:'',
				orderId:'',
				hfId:''
			}
		},
		methods:{
			pollGetOrder(){
				let orderId = this.$route.params.orderId;
				if(!orderId){
					orderId = this.sOrderId;
				}
				// this.hfId = _hfId
				this.orderId = orderId;
				// this.orderId = 2652;
				
				this.getOrder();
				if( this.orderDetail.orderType == 1){
					this.orderTimer = setInterval(this.pollTimer, 3000);
				}
				// if()
			},
			getOrder(){
				getOrderById({
					id:this.orderId
				}).then(res => {
					// console.log(res)
					res.starSubOrders.forEach(childItem =>{
						childItem.goodsId = childItem.foodId;
						childItem.goodsName = childItem.foodName;
						childItem.goodsNum = childItem.foodNum;
						childItem.goodsSpec = childItem.specification;
						childItem.thumb = childItem.thumb;
						childItem.goodsEndPrice = childItem.foodEndPrice;
					})
					if(this.orderDetail){
						this.orderDetail.status = res.status;
						this.orderDetail.takeFoodCode = res.takeFoodCode;
					}else{
						this.orderDetail = res
					}
					if(this.orderDetail.hfOrderId!=""){
						this.hfId = this.orderDetail.hfOrderId
					}
				})  
			},
			//定时器-订单相关
			pollTimer(){
				if(this.orderDetail.status >= 3){
					this.stopOrderTimer();
				}else{
					this.getOrder(this.orderId);
				}
			},
			stopOrderTimer(){
				clearInterval(this.orderTimer);
			}
		}
	}
</script>

<style scoped>
	.box {
		width: 100%;
		min-height: 100%;
		background-color: #f5f5f5;
		padding: 10px;
	}
	
	.shop-detail-div,.shop-pay-goods-div {
		margin-top: 10px;
		
	}
	.emtry-div {
		width: 100%;
		height: 70px;
	}
	
</style>
